/**
 * ロール別ユーザー数の表示用ユーティリティ
 */

const ADMIN_ROLE = { value: 'admin', label: '管理者' };

/** API 取得前の表示用（server/helpers/rolesHelper.js の DEFAULT_ROLES と同期） */
export const DEFAULT_ROLES = [
  { label: '歯科医師', value: 'doctor' },
  { label: '歯科衛生士', value: 'dental_hygienist' },
  { label: '歯科助手', value: 'dental_assistant' },
  { label: 'その他', value: 'other' },
];

export function getRoleLabel(roleList, roleValue) {
  if (!roleValue) return '—';
  if (roleValue === ADMIN_ROLE.value) return ADMIN_ROLE.label;
  const list = roleList?.length ? roleList : DEFAULT_ROLES;
  const found = list.find((r) => r.value === roleValue);
  return found?.label || roleValue;
}

/**
 * ダッシュボード等で表示するロール別件数（管理者 + 設定ロール + 未登録ロール）
 */
export function buildRoleStatEntries(byRole = {}, roleList = []) {
  const entries = [
    { value: ADMIN_ROLE.value, label: ADMIN_ROLE.label, count: byRole[ADMIN_ROLE.value] || 0 },
  ];

  for (const role of roleList || []) {
    if (!role?.value || role.value === ADMIN_ROLE.value) continue;
    entries.push({
      value: role.value,
      label: role.label || role.value,
      count: byRole[role.value] || 0,
    });
  }

  for (const [value, count] of Object.entries(byRole)) {
    if (!count || value === ADMIN_ROLE.value) continue;
    if (entries.some((e) => e.value === value)) continue;
    entries.push({ value, label: value, count });
  }

  return entries;
}

/**
 * Firebase Auth 用仮想メール（userId@clinicId.clinic）
 */
export function formatVirtualEmail(userId, clinicId) {
  const id = (userId || '').trim();
  const cid = (clinicId || '').trim();
  if (!id || !cid) return '';
  return `${id}@${cid}.clinic`;
}
